import * as DatasetHelper from '../dataset-helper';

/**
 * Utility method to determine if the value is a scalar or a property. A property value must be
 * encapsulated by '${}'
 */
function isProperty(value) {
  return value && (typeof value === 'string') && value.startsWith('${') && value.endsWith('}');
}

/**
 * Utility method to return the property name from the value.
 */
function getProperty(value) {
  return value.substring(2, value.length - 1);
}

/**
 * Perform {@code SquareRoot} based on the configuration.
 */
export default function calculate(statistics, dataset, categoryFieldId, calculationStepDefn) {

  if (calculationStepDefn.result.startsWith('category.')) {

    // Category-level calculation.

    const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
    const categories = categoryField.categories;
    const numOfCategories = categories.length;
    categories.forEach(category => {
      const categoryResult = statistics[category.value];
      if (!categoryResult) {
        throw new Error(`Unable to find category results for \"${category.value}\"`);
      }

      // Identify the property.
      let propertyValue = undefined;
      const propertyDefn = calculationStepDefn.property;
      if (isProperty(propertyDefn)) {
        // Property.
        const fullPropertyName = getProperty(propertyDefn);
        const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
        propertyValue = (fullPropertyName.startsWith('category.') ?
          categoryResult[propertyName] :
          statistics[propertyName]);
      } else {
        // Scalar.
        propertyValue = propertyDefn;
      }

      // Assign the result.
      const resultFieldName = calculationStepDefn.result.substring(calculationStepDefn.result.indexOf('.') + 1);
      categoryResult[resultFieldName] = Math.sqrt(propertyValue);

    });

  } else {

    // Field-level calculation.

    // Identify the property.
    let propertyValue = undefined;
    const propertyDefn = calculationStepDefn.property;
    if (isProperty(propertyDefn)) {
      const fullPropertyName = getProperty(propertyDefn);
      const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
      propertyValue = statistics[propertyName];
    } else {
      propertyValue = propertyDefn;
    }

    // Assign the result.
    const resultFieldName = calculationStepDefn.result.substring(calculationStepDefn.result.indexOf('.') + 1);
    statistics[resultFieldName] = Math.sqrt(propertyValue);

  }

}


// WEBPACK FOOTER //
// ./src/app/utils/calculators/sqrt-calculator.js